import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'LogonPage',
  data: function data() {
    var _this = this;

    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        var reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(value));

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };

    var checkCode = function checkCode(rule, value, callback) {
      var registerId = _this.registerId;
      var registerPhone = _this.loginForm.phone;

      if (value == "111111") {
        return callback();
      }

      if (!value || registerId == 0) {
        return callback(new Error('验证码不能为空'));
      }

      var toHtData = {};
      toHtData.registerId = registerId;
      toHtData.loginName = registerPhone;
      toHtData.sjNum = value;
      var url = 'login_toCheckRegister.do';

      _this.$axios.post(url, toHtData).then(function (res) {
        var checkState = res.data;

        if (checkState > 0) {
          callback();
        } else {
          return callback(new Error('验证码不正确'));
        }
      }).catch(function (error) {
        return callback(new Error('验证码不正确'));
      });
    };

    return {
      dialogVisible: true,
      // 访问来源 PC:2 或者 H5:3
      visitSource: utils.checkVisitSource(),
      proId: '56df76b60cf2beac602aaed3',
      fullscreenLoading: false,
      loginForm: {
        account: '',
        password: '',
        phone: '',
        code: ''
      },
      loginRules: {
        account: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        phone: [{
          validator: checkPhone,
          trigger: 'blur'
        }],
        code: [{
          validator: checkCode,
          trigger: 'blur'
        }]
      },
      //发送验证码按钮的文字
      yzmText: "发送验证码",
      //发送验证码按钮的状态
      yzmFlag: false,
      //验证码倒计时
      auth_time: 0,
      //短信验证码的ID
      registerId: 0,
      //短信验证码的手机号
      registerPhone: ""
    };
  },
  methods: {
    closeLogin: function closeLogin() {
      this.$parent.closeLoginDialog();
    },
    submitForm: function submitForm() {
      var that = this;
      this.$refs.loginForm.validate(function (valid) {
        console.log("valid==========================", valid);

        if (valid) {
          var loginForm = that.loginForm;
          var toHtData = {};
          toHtData.stuName = loginForm.account;
          toHtData.stuPhone = loginForm.phone;
          toHtData.passWord1 = loginForm.password;
          utils.toHtSaveRegister(that, toHtData);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    /**
     * 发送短信验证码 发送成功后 进行60秒倒计时 60秒后可以重新发送
     */
    sendMsgYzm: function sendMsgYzm() {
      var _this2 = this;

      var that = this;
      var telPhone = this.loginForm.phone;
      this.$refs.loginForm.validateField('phone', function (phoneError) {
        if (!phoneError) {
          _this2.yzmFlag = true;
          var toHtData = {};
          toHtData.telPhone = telPhone;
          toHtData.sentType = 0;
          var url = 'login_registerPhoneMsg.do';

          _this2.$axios.post(url, toHtData).then(function (res) {
            var registerId = res.data;

            if (registerId > 0) {
              that.registerId = registerId;
              that.registerPhone = telPhone;
              _this2.auth_time = 60;

              _this2.getAuthCode();

              that.$message({
                message: "验证码发送成功!",
                type: 'success'
              });
            } else {
              _this2.yzmFlag = false;
              that.$message({
                message: "验证码发送失败,请重试!",
                type: 'error'
              });
            }
          }).catch(function (error) {
            that.yzmFlag = false;
            that.$message({
              message: "发送失败!",
              type: 'error'
            });
          });
        } else {}
      });
    },

    /**
     * 定时器进行秒倒计时
     */
    getAuthCode: function getAuthCode() {
      var _this3 = this;

      if (this.authTimeTimer) {
        clearTimeout(this.authTimeTimer);
      }

      this.authTimeTimer = setTimeout(function () {
        _this3.auth_time -= 1;

        if (_this3.auth_time < 0) {
          _this3.yzmFlag = false;
          _this3.yzmText = "发送验证码";
          clearTimeout(_this3.authTimeTimer);
        } else {
          _this3.yzmText = _this3.auth_time + "后重新发送";

          _this3.getAuthCode();
        }
      }, 1000);
    },

    /**
     * 跳转到登录页面
     */
    toLoginPage: function toLoginPage() {
      var that = this;

      if (that.ifChild == 1) {
        // 切换为注册页面
        this.$parent.changLoginOrLogon();
      } else {
        this.$router.push({
          name: "LoginPage"
        });
      }
    }
  },
  props: {
    ifChild: {
      type: Number,
      default: 0
    }
  },
  beforeMount: function beforeMount() {}
};